module.exports = __webpack_public_path__ + "static/media/institute-27-min.cc517688.webp";